module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "Ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNI"
  }, [_vm._v("I greatly appreciate the expertise, support, and encouragement that our sources, readers, friends, and family have given us over the years. Because of you, our stories will continue.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 71
// module chunks = 0